import { useEffect } from "react";

const SITE = "https://thehonestdonkey.com";

function setTag(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    if (selector.startsWith('meta[name=')) el.setAttribute("name", selector.match(/name="([^"]+)"/)[1]);
    if (selector.startsWith('meta[property=')) el.setAttribute("property", selector.match(/property="([^"]+)"/)[1]);
    if (selector.startsWith("link")) el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

// Per-route SEO: unique title, meta description, canonical + OG/Twitter, optional noindex.
// Dependency-free; crawlers that render JS pick these up. Apply to each public page.
export default function useSeo({ title, description, path = "", noindex = false, image }) {
  useEffect(() => {
    const canonical = SITE + path;
    if (title) document.title = title;
    if (description) {
      setTag('meta[name="description"]', "content", description);
      setTag('meta[property="og:description"]', "content", description);
      setTag('meta[name="twitter:description"]', "content", description);
    }
    if (title) {
      setTag('meta[property="og:title"]', "content", title);
      setTag('meta[name="twitter:title"]', "content", title);
    }
    setTag('meta[property="og:url"]', "content", canonical);
    setTag('link[rel="canonical"]', "href", canonical);
    if (image) {
      setTag('meta[property="og:image"]', "content", image.startsWith("http") ? image : SITE + image);
    }
    setTag('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow");
    return () => { setTag('meta[name="robots"]', "content", "index, follow"); };
  }, [title, description, path, noindex, image]);
}
